import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-select-registrant-type-moda',
  templateUrl: './select-registrant-type-modal.component.html',
  styleUrls: ['./select-registrant-type-modal.component.css'],
  imports: [],
  standalone: true
})
export class SelectRegistrantTypeModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  close() {
    this.activeModal.close(undefined);
  }

  registerByMySelf() {
    this.activeModal.close('SELF');
  }

  registerByGuarantor() {
    this.activeModal.close('GUARANTOR');
  }
}
